import {Injectable} from '@angular/core';
import {Navigate} from '@ngxs/router-plugin';
import {Action, State, StateContext, StateToken, Selector, NgxsOnInit} from '@ngxs/store';
import {Observable, throwError} from 'rxjs';
import {catchError, switchMap, tap} from 'rxjs/operators';
import {StateResetAll} from 'ngxs-reset-plugin';
import {Cheque, ChequeCotizacion, ChequeCotizacionDetail, ChequeParameters, ChequeRequest} from "../models/cheque.model";
import {
  CambiarAceptaOfertaChequeAction,
  CambiarMontoEsperadoChequeAction,
  ComprarChequeAction,
  DescontarChequeAction, EliminarChequeAction, GetChequeAction, GetChequeCotizacionAction,
  GetChequeParaInversionListAction, GetChequeParametersAction, GetChequePropioListAction,
  OfertarPorChequeAction, RedescontarChequeAction,
  SearchChequeCotizacionListAction
} from "../actions/cheque.actions";
import {ChequeApiService} from "../api/cheque.api.service";
import {ChequeCotizacionListFilter} from "../models/cotizacion-list-filter.model";
import {PageableApiResult} from "../models/pagable-api-result.model";
import {Constants} from "../util/constants";
import {ChequePortfolioFilter} from '../models/cheque-portfolio-filter.model';
import {OfertaListFilter} from '../models/oferta.model';

export interface ChequeStateModel {
  carteraPropiaFilter: ChequePortfolioFilter,
  carteraParaInversionFilter: ChequePortfolioFilter,
  carteraPropia: PageableApiResult<Cheque>,
  carteraParaInversion: PageableApiResult<Cheque>,
  chequeList: Cheque[],
  cheque: Cheque,
  chequeCotizacionListFilter: ChequeCotizacionListFilter,
  chequeCotizacionPageableList: PageableApiResult<ChequeCotizacion>,
  chequeCotizacionDetail:ChequeCotizacionDetail,
  chequeParameters:ChequeParameters,
}

const initialState: ChequeStateModel = {
  carteraPropiaFilter: null,
  carteraParaInversionFilter: null,
  carteraPropia: null,
  carteraParaInversion: null,
  chequeList: null,
  chequeCotizacionListFilter: null,
  chequeCotizacionPageableList: null,
  chequeCotizacionDetail:null,
  cheque: null,
  chequeParameters:null,
};

const CHEQUE_STATE_TOKEN = new StateToken<ChequeStateModel>('cheque');

@State<ChequeStateModel>({
  name: CHEQUE_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class ChequeState {

  constructor(
    private chequeApiService: ChequeApiService
  ) {
  }

  @Action(GetChequePropioListAction)
  handleGetChequePropioListAction(ctx: StateContext<ChequeStateModel>, action: GetChequePropioListAction) {
    const filter = ctx.getState()?.carteraPropiaFilter;
    const actionFilter = action.payload.filter;
    let reqFilter: ChequePortfolioFilter
    if (filter) {

      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: 10,
      }
    }

    ctx.patchState({
      carteraPropia: null,
    })

    return this.chequeApiService.getChequePropioList(reqFilter).pipe(
      tap(cartera => {
        const state = ctx.getState();

        ctx.patchState({
          carteraPropia:cartera,
          carteraPropiaFilter: reqFilter,
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetChequeParaInversionListAction)
  handleGetChequeParaInversionListAction(ctx: StateContext<ChequeStateModel>, action: GetChequeParaInversionListAction) {

    const filter = ctx.getState()?.carteraParaInversionFilter;
    const actionFilter = action.payload.filter;

    let reqFilter: ChequePortfolioFilter
    if (filter) {

      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: 10,
      }
    }

    ctx.patchState({
      carteraParaInversion: null,

    })

    return this.chequeApiService.getChequeParaInversionList(reqFilter).pipe(
      tap(cartera => {
        const state = ctx.getState();

        ctx.patchState({
          carteraParaInversion:cartera,
          carteraParaInversionFilter:reqFilter
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(GetChequeAction)
  handleGetChequeAction(ctx: StateContext<ChequeStateModel>, action: GetChequeAction) {

    const {cehqueId} = action.payload;


    return this.chequeApiService.getCheque(cehqueId).pipe(
      tap(cheque => {
        const state = ctx.getState();

        ctx.patchState({
          cheque
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(DescontarChequeAction)
  handleDescontarChequeAction(ctx: StateContext<ChequeStateModel>, action: DescontarChequeAction) {

    let chequeRequest: ChequeRequest = action.payload;

    return this.chequeApiService.descontarCheque(chequeRequest).pipe(
      tap(nuevoCheque => {
        const state = ctx.getState();

        ctx.patchState({
          chequeList: [...state?.chequeList || [], nuevoCheque]
        })

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(RedescontarChequeAction)
  handleRedescontarChequeAction(ctx: StateContext<ChequeStateModel>, action: RedescontarChequeAction) {

    let chequeId = action.payload.chequeId;
    let montoEsperado = action.payload.montoEsperado;

    return this.chequeApiService.redescontarCheque(chequeId, montoEsperado).pipe(
      tap(nuevoCheque => {

      }),
      catchError(err => {
        return throwError(err)
      })
    );
  }

  @Action(OfertarPorChequeAction)
  handleOfertarPorChequeAction(ctx: StateContext<ChequeStateModel>, action: OfertarPorChequeAction) {

    // let chequeId = action.payload.chequeId;
    // let importeEsperado = action.payload.importeEsperado;
    // let horasVencimiento = action.payload.horasVencimiento;
    // let horasAcreditacion = action.payload.horasAcreditacion;

    return this.chequeApiService.realizarOfertaPorCheque(action.payload).pipe(
      catchError(err => {
        if(err == 409) {
          return throwError(err)
        }
        return throwError(err.error)
      })
    );
  }

  @Action(ComprarChequeAction)
  handleComprarChequeAction(ctx: StateContext<ChequeStateModel>, action: ComprarChequeAction) {

    let chequeId: number = action.payload.chequeId;

    // return this.chequeApiService.comprarCheque(chequeId).pipe(switchMap(response => {
    //   return ctx.dispatch(new SearchChequeCotizacionListAction({filter:ctx.getState().chequeCotizacionListFilter}))
    // }));
    return this.chequeApiService.comprarCheque(chequeId);
  }

  @Action(SearchChequeCotizacionListAction)
  handleSearchChequeCotizacionList(ctx: StateContext<ChequeStateModel>, action: SearchChequeCotizacionListAction) {
    // Check for status options in state
    const filter = ctx.getState()?.chequeCotizacionListFilter;
    const actionFilter = action.payload.filter

    let reqFilter: ChequeCotizacionListFilter

    if (filter || actionFilter) {

      reqFilter = {
        ...filter,
        ...actionFilter
      }

    } else {
      //filtros por defecto:
      reqFilter = {
        page: 0,
        size: Constants.PAGE_SIZE_EXCHANGE,
        dateFilter: actionFilter.dateFilter,
        minimo:null,
        maximo:null,
        rendimientoMinimo:null,
        rendimientoMaximo:null,
        scoringEndosante:null,
        scoringLibrador:null,
        tipoCheque:null,
        propio: null,
        sortByMargen:'ASC'
      }
    }

    ctx.patchState({
      chequeCotizacionListFilter: reqFilter
    })

    return this.chequeApiService.searchChequeCotizacionList(reqFilter).pipe(
      tap(data => {
        ctx.patchState({
          chequeCotizacionPageableList: data
        })
      })
    )
  }

  @Action(GetChequeCotizacionAction)
  handleGetChequeCotizacionAction(ctx: StateContext<ChequeStateModel>, action: GetChequeCotizacionAction) {
    // Check for status options in state
    const chequeId = action.payload.id;

    return this.chequeApiService.getChequeCotizacionById(chequeId).pipe(
      tap(chequeCotizacionDetail => {
        ctx.patchState({
          chequeCotizacionDetail
        })
      })
    )
  }


  @Action(GetChequeParametersAction)
  handleGetChequeParametersAction(ctx: StateContext<ChequeStateModel>, action: GetChequeParametersAction) {
    return this.chequeApiService.getChequeParameters().pipe(
      tap(chequeParameters => {
        ctx.patchState({
          chequeParameters
        })
      })
    )
  }

  @Action(CambiarMontoEsperadoChequeAction)
  handleCambiarMontoEsperadoChequeAction(ctx: StateContext<ChequeStateModel>, action: CambiarMontoEsperadoChequeAction) {
    let {chequeId, nuevoEsperado} = action.payload;
    return this.chequeApiService.cambiarMontoEsperadoCheque(chequeId, nuevoEsperado).pipe(
      tap(chequeParameters => {

      })
    )
  }

  @Action(CambiarAceptaOfertaChequeAction)
  handleCambiarAceptaOfertaChequeAction(ctx: StateContext<ChequeStateModel>, action: CambiarAceptaOfertaChequeAction) {
    let aceptaOferta = action.payload.aceptaOferta;
    let chequeId = action.payload.chequeId;
    return this.chequeApiService.cambiarAceptaOfertaCheque(chequeId, aceptaOferta).pipe(
      tap(chequeParameters => {

      })
    )
  }

  @Action(EliminarChequeAction)
  handleEliminarChequeAction(ctx: StateContext<ChequeStateModel>, action: EliminarChequeAction) {
    let {chequeId} = action.payload;
    return this.chequeApiService.eliminar(chequeId).pipe(
      tap(chequeParameters => {

      })
    )
  }

  @Selector()
  static getCarteraPropia(state: ChequeStateModel): PageableApiResult<Cheque> {
    return state?.carteraPropia
  }

  @Selector()
  static getCarteraParaInversion(state: ChequeStateModel): PageableApiResult<Cheque> {
    return state?.carteraParaInversion
  }

  @Selector()
  static getChequeList(state: ChequeStateModel): Cheque[] {
    return state?.chequeList
  }

  @Selector()
  static getCheque(state: ChequeStateModel) {
    return state?.cheque
  }

  @Selector()
  static getChequeCotizacionList(state: ChequeStateModel) {
    return state?.chequeCotizacionPageableList
  }

  @Selector()
  static getChequeCotizacionDetail(state: ChequeStateModel) {
    return state?.chequeCotizacionDetail;
  }

  @Selector()
  static getChequeParameters(state: ChequeStateModel):ChequeParameters {
    return state?.chequeParameters;
  }
  @Selector()
  static getChequeCotizacionesListFilter(state: ChequeStateModel): ChequeCotizacionListFilter {
    return state?.chequeCotizacionListFilter;
  }

}
